/**
 * data API
 * data API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from "@angular/common/http";
import { CustomHttpUrlEncodingCodec } from "../encoder";

import { Observable } from "rxjs";

import { Data } from "../model/data";
import { ObjectQuery } from "../model/objectQuery";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

@Injectable()
export class EngineQueryService {
  protected basePath = "https://dmp.airiane.com/services/engine";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    console.log("TEST JORIS");
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = "multipart/form-data";
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * getData
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDataUsingGET(
    observe?: "body",
    reportProgress?: boolean
  ): Observable<ObjectQuery>;
  public getDataUsingGET(
    observe?: "response",
    reportProgress?: boolean
  ): Observable<HttpResponse<ObjectQuery>>;
  public getDataUsingGET(
    observe?: "events",
    reportProgress?: boolean
  ): Observable<HttpEvent<ObjectQuery>>;
  public getDataUsingGET(
    observe: any = "body",
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ["*/*"];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.get<ObjectQuery>(`${this.basePath}/api/data`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * getQueryData
   *
   * @param query query
   * @param page Page number of the requested page
   * @param size Size of a page
   * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getQueryDataUsingPOST(
    query: ObjectQuery,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean
  ): Observable<Array<Data>>;
  public getQueryDataUsingPOST(
    query: ObjectQuery,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "response",
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Data>>>;
  public getQueryDataUsingPOST(
    query: ObjectQuery,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "events",
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Data>>>;
  public getQueryDataUsingPOST(
    query: ObjectQuery,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe: any = "body",
    reportProgress: boolean = false
  ): Observable<any> {
    if (query === null || query === undefined) {
      throw new Error(
        "Required parameter query was null or undefined when calling getQueryDataUsingPOST."
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set("page", <any>page);
    }
    if (size !== undefined && size !== null) {
      queryParameters = queryParameters.set("size", <any>size);
    }
    if (sort) {
      sort.forEach((element) => {
        queryParameters = queryParameters.append("sort", <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ["*/*"];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected:
      | string
      | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<Array<Data>>(
      `${this.basePath}/api/data/query`,
      query,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
